import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { fetchUsers } from '../lib/api'
import { DEFAULT_EMBEDS } from '../providers/UserAPIProvider'
import { AppDispatch, RootState } from '../store'

//-name is desc
type ContactsTableState = {
  tableApiSort: Array<TableApiSort>
  sort: Array<'' | string>
  pagination: IndexPagination
}

const initialPagination: IndexPagination = {
  page: 0,
  per_page: 25,
  total: 0
}

const initialState: ContactsTableState = {
  sort: [],
  tableApiSort: [],
  pagination: { ...initialPagination }
}

export const usersTableSlice = createSlice({
  name: 'usersTable',
  initialState: initialState,
  reducers: {
    setPagination: (state, { payload }: PayloadAction<IndexPagination>) => {
      state.pagination = payload
    },

    setPaginationPage: (state, { payload }: PayloadAction<number>) => {
      state.pagination.page = payload
    },

    setPaginationSize: (state, { payload }: PayloadAction<number>) => {
      state.pagination.per_page = payload
    },

    resetPagination: state => {
      state.pagination = { ...initialPagination }
    },

    setSort: (
      state: ContactsTableState,
      {
        payload
      }: PayloadAction<{
        sort: Array<'' | string>
        apiTableSort: Array<TableApiSort>
      }>
    ) => {
      const { sort, apiTableSort } = payload
      state.sort = sort
      state.tableApiSort = apiTableSort
    }
  }
})

export default usersTableSlice.reducer

export const {
  setPagination,
  resetPagination,
  setPaginationPage,
  setPaginationSize,
  setSort
} = usersTableSlice.actions

export const selectUsersTable = (state: RootState) => state.usersTable

export const fetchPageOfUsers = (
  external: boolean,
  limit?: number,
  page?: number,
  ownerId?: string,
  sort?: string[],
  cb?: (data: APIUser[]) => void
) => {
  return async (dispatch: AppDispatch) => {
    try {
      const result = await fetchUsers(
        DEFAULT_EMBEDS,
        external,
        limit,
        page,
        ownerId,
        sort
      )
      dispatch(setPagination(result.pagination))
      cb && cb(result.data)
    } catch (err) {
      console.error('Error loading users', err)
      cb && cb([])
    }
  }
}
